import { AcceptancePage } from "@hubcapp/layouts";
import { Brand } from "@ds-developer/models";
import AcceptancePageCheck from "./AcceptancePageCheck";
import React, { useEffect } from "react";
type Props = {
  brand: string;
  personKey: string;
  agreementKey: string;
};

const AcceptancePageCheckStateProvider: React.FC<Props> = ({
  brand,
  personKey,
  agreementKey,
}) => {
  useEffect(() => {
    if (brand === Brand.Bsm) {
      document.documentElement.style.setProperty("--brand-font", "Poppins");
    } else {
      document.documentElement.style.setProperty(
        "--brand-font",
        "New Transport AA",
      );
    }
  }, []);

  return (
    <AcceptancePage
      brand={brand === "BSM" ? Brand.Bsm : Brand.Aad}
      headerTitle="Driving instructor franchise"
    >
      <AcceptancePageCheck
        brand={brand}
        personKey={personKey}
        agreementKey={agreementKey}
      />
    </AcceptancePage>
  );
};

export default AcceptancePageCheckStateProvider;
